<div class="ba-field-group">
    <div class="centered">
        <img [src]="asset('assets/images/account-limit.svg')" alt="account limit">
    </div>
</div>
<p class="ibk-description">
    Exceder&aacute;s el l&iacute;mite de Cuentas Negocio para Persona Natural
</p>
<div class="ba-field-group centered">
    <span>No puedes solicitar la apertura en ambas monedas porque exceder&aacute;s el n&uacute;mero permitido de cuentas
        con este documento de identidad. Selecciona solo un tipo de moneda para continuar.</span>
</div>
<ibk-button class="ba-action" [loading]="isLoading">
    <button id="btn-resend-code" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
        (click)="stepConfiguration()">
        Entendido
    </button>
</ibk-button>